import { Component, OnInit } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { CookieService } from "ngx-cookie-service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-seamless-header",
  templateUrl: "./seamless-header.component.html",
  styleUrls: ["./seamless-header.component.css"],
  standalone: true,
})
export class SeamlessHeaderComponent implements OnInit {
  constructor(
    private oauthService: OAuthService,
    private cookieService: CookieService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {}

  logout() {
    this.spinner.show();
    setTimeout(() => {
      (window as any).fcWidget.destroy();

      ///Note on remove Cookies or Storage:- What code you going to apply here for remove Keys, Must apply the same code in(app.component, auth.interceptor)
      this.cookieService.delete("submissionId", "/");
      this.cookieService.delete("uType", "/");
      this.cookieService.delete("userId", "/");
      localStorage.removeItem("isLoginSuccess");
      sessionStorage.removeItem("sessionId");
      sessionStorage.removeItem("isRedirected");
      sessionStorage.clear();
      localStorage.clear();

      this.oauthService.logOut();
      this.spinner.hide();
    }, 1000);
  }
}
